import TableCellRenderer from '@cp/src/components/TableCellRenderer';
import CellRendererShortNumber from '@cp/src/components/TableCellRenderer/CellRendererShortNumber';
import { ColDefsType } from '@navi/web-ui/lib/components/AgTable/types';
import { ICellRendererParams } from 'ag-grid-community';
import { Button, Tag, Typography } from '@navi/web-ui/lib/primitives';
import { getTagColor } from '../../CsaTicketing/utils';
import { getSanitizedEnumValue, pluralisation } from '@cp/src/utils/commonUtils';
import { TicketStatusMap } from '../../CsaTicketing/constants';
import styles from '../index.module.scss';
import { ITableTicket } from '../types';
import TimeAgo from '@cp/src/components/TimeAgo';

export const tooltipContentClass = 'z-[var(--z-index-external-sensei-tooltip)]';

export const getFieldSupportColumnDefs = (viewDetailsHandler: (ticket: ITableTicket) => void) => {
  return [
    {
      field: 'taskType',
      headerComponent: 'Request Type',
      width: 156,
      cellRenderer: (params: ICellRendererParams) => {
        const { requestTypeLabel, newUpdatesCount } = params.data || {};
        return (
          <div>
            {newUpdatesCount ? (
              <Typography variant="h6" color="#518CFF">
                {newUpdatesCount} {pluralisation('update', newUpdatesCount, 's')}
              </Typography>
            ) : null}
            <div className="flex items-center gap-2">
              <TableCellRenderer
                value={requestTypeLabel}
                toolTipContent={requestTypeLabel}
                showToolTip
                tooltipContentClass={tooltipContentClass}
              />
            </div>
          </div>
        );
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 170,
      wrapHeaderText: true,
      serverSortable: true,
      cellRenderer: (params: ICellRendererParams) => {
        const { status } = params?.data || {};
        return (
          <Tag
            color={getTagColor(status)}
            variant="transparent"
            label={getSanitizedEnumValue(TicketStatusMap, status)}
          />
        );
      }
    },
    {
      field: 'customerName',
      headerName: 'Customer Name',
      width: 220,
      wrapHeaderText: true,
      cellRenderer: (params: ICellRendererParams) => {
        const { customerName } = params.data || {};
        return (
          <TableCellRenderer
            value={customerName}
            toolTipContent={customerName}
            showToolTip
            tooltipContentClass={tooltipContentClass}
          />
        );
      }
    },
    {
      field: 'loanAccountNumber',
      headerName: 'LAN',
      width: 140,
      wrapHeaderText: true,
      cellRenderer: (params: ICellRendererParams) => {
        const { loanAccountNumber } = params.data || {};
        return (
          <TableCellRenderer
            value={loanAccountNumber}
            toolTipContent={loanAccountNumber}
            showToolTip
            tooltipContentClass={tooltipContentClass}
          />
        );
      }
    },
    {
      field: 'overdueAmount',
      headerName: 'Overdue',
      width: 116,
      wrapHeaderText: true,
      cellRenderer: (params: ICellRendererParams) => {
        const { overdueAmount } = params?.data || {};
        return (
          <CellRendererShortNumber
            value={overdueAmount?.value}
            isCurrency
            significantDigits={2}
            tooltipContentClass={tooltipContentClass}
          />
        );
      }
    },
    {
      field: 'requestedBy',
      headerName: 'Requested By',
      width: 200,
      wrapHeaderText: true,
      cellRenderer: (params: ICellRendererParams) => {
        const { requestedBy } = params.data || {};
        return (
          <TableCellRenderer
            value={requestedBy?.name}
            toolTipContent={requestedBy?.name}
            showToolTip
            tooltipContentClass={tooltipContentClass}
          />
        );
      }
    },
    {
      field: 'createdAt',
      headerName: 'Raised at',
      width: 110,
      wrapHeaderText: true,
      serverSortable: true,
      cellRenderer: (params: ICellRendererParams) => {
        const { createdAt, referenceId } = params.data || {};
        return <TimeAgo key={referenceId} epoch={createdAt} ellipsisClass={styles.ellipsisClass} />;
      }
    },
    {
      field: 'referenceId',
      headerName: 'Actions',
      width: 120,
      wrapHeaderText: true,
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <Button variant="text" onClick={() => viewDetailsHandler(params?.data)}>
            View Details
          </Button>
        );
      }
    }
  ] as ColDefsType[];
};
